import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Menu from '../../panel/Menu';

function Dailycashreport() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
        });
    });
    const printRef = useRef();
    const [loading, setloading] = useState(false);
    const [userData, setUserData] = useState();
    const [fromDate, setfromDate] = useState("");
    const [toDate, settoDate] = useState("");
    const [bookingData, setbookingData] = useState([]);


    const getReport = async () => {

        if (!fromDate) {
            Toast.fire({ icon: "error", title: "Please select date" });
            return;
        }

        setloading(false);
        setbookingData([]);

        try {

            // 1️⃣ Fetch all roomtypes
            const roomtypesSnapshot = await getDocs(collection(db, "roomtypes"));
            const roomtypesData = roomtypesSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));

            // 2️⃣ Fetch bookings by checkin date
            const bookingQuery = query(
                collection(db, "bookings"),
                where("checkindate", "==", fromDate)
            );

            const bookingSnapshot = await getDocs(bookingQuery);

            let allRooms = [];

            bookingSnapshot.forEach(doc => {
                const data = doc.data();

                const noofdays = parseFloat(data.noofdays) || 1;

                console.log(data );
                
                // ✅ per day service amount
                const servicePerDay =
                    parseFloat(data.serviceamount || 0) / noofdays;

                if (data.rooms && Array.isArray(data.rooms)) {
                    data.rooms.forEach(room => {
                        allRooms.push({
                            ...room,
                            extraPerDay: servicePerDay
                        });
                    });
                }
            });


            const finalData = roomtypesData.map(rtype => {

                const filtered = allRooms.filter(
                    room => room.rtypeid === rtype.id
                );

                const roomCount = filtered.length;

                const roomTotal = filtered.reduce(
                    (sum, room) => sum + Number(room.roomrate || 0),
                    0
                );

                const extraTotal = filtered.reduce(
                    (sum, room) => sum + Number(room.extraPerDay || 0),
                    0
                );

                const avgRate = roomCount > 0
                    ? roomTotal / roomCount
                    : 0;

                return {
                    roomtype: rtype.roomtype,
                    rate: Math.round(avgRate),
                    roomCount,
                    extraTotal: Math.round(extraTotal),
                    totalAmount: Math.round(roomTotal + extraTotal)
                };

            });

            // 🔥 Calculate Grand Totals
            const grandRoomTotal = finalData.reduce(
                (sum, item) => sum + item.totalAmount,
                0
            );

            const grandExtraTotal = finalData.reduce(
                (sum, item) => sum + item.extraTotal,
                0
            );

            const grandRooms = finalData.reduce(
                (sum, item) => sum + item.roomCount,
                0
            );

            setbookingData({
                rows: finalData,
                grandRoomTotal,
                grandExtraTotal,
                grandRooms
            });

            setloading(true);

        } catch (error) {
            console.log(error);
            Toast.fire({ icon: "error", title: "Something went wrong" });
        }
    };



    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    })

    const handleFromDate = (e) => {
        setfromDate(e.target.value)
        setloading(false)
    }
    const handleToDate = (e) => {
        settoDate(e.target.value)
        setloading(false)
    }

    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " >|| Daily Cash Report ||</button><br /><br />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary card-outline">
                                    <div className="card-body">
                                        <div className='row'>
                                            <div className='col-sm-3'>
                                                <label> Date</label>
                                                <input type='date' value={fromDate} onChange={handleFromDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-3'>
                                                <br />
                                                <button className='btn btn-info' onClick={getReport}>Get Report</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    loading &&
                                    <>
                                        <div className="card card-primary card-outline" ref={printRef}>
                                            <div className="card-body">
                                                <div className="row invoice-info">
                                                    <div className="col-sm-12 invoice-col text-center">
                                                        <address>
                                                            <h4>Dasara Executive</h4>
                                                            Chatrapati Shivaji Maharaj Chouk, Tuljapur, Dist - Dharashiv, MH - 413601<br />
                                                            Phone: +91 9975294940 |
                                                            Email:  dasaraexecutive@gmail.com<br />
                                                            Website:  www.dasaraexecutive.com
                                                        </address>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <table className='customers '>
                                                        <tr>
                                                            <td style={{ textAlign: "center" }}><h5 style={{ textTransform: "uppercase" }}>Daily Cash Report -  {moment(fromDate).format('DD/MM/YYYY')}</h5></td>
                                                        </tr>
                                                    </table>
                                                    <table className="customers">
                                                        <thead>
                                                            <tr>
                                                                <th>Sr No</th>
                                                                <th>Room Type</th>
                                                                <th>Rate</th>
                                                                <th>No of Rooms</th>
                                                                <th>Extra Rate</th>
                                                                <th>Food Bill</th>
                                                                <th style={{ textAlign: "right" }}>Total</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                bookingData.rows?.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>
                                                                        <td>{item.roomtype}</td>
                                                                        <td>{item.rate || 0}</td>
                                                                        <td>{item.roomCount}</td>
                                                                        <td>{item.extraTotal.toFixed(2)}</td>
                                                                        <td>0</td>
                                                                        <td style={{ textAlign: "right" }}>
                                                                            {item.totalAmount.toFixed(2)}
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            }
                                                            {
                                                                bookingData.rows && (
                                                                    <tr style={{ fontWeight: "bold", backgroundColor: "#f2f2f2" }}>
                                                                        <td colSpan="3" style={{ textAlign: "right" }}>Grand Total</td>
                                                                        <td>{bookingData.grandRooms}</td>
                                                                        <td>{bookingData.grandExtraTotal}</td>
                                                                        <td>0</td>
                                                                        <td style={{ textAlign: "right" }}>
                                                                            {bookingData.grandRoomTotal}
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            }

                                                        </tbody>


                                                    </table>

                                                </div>
                                            </div>

                                        </div>
                                        <center>
                                            <button className='btn btn-success' onClick={handlePrint}>Print Report</button>
                                        </center>
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                </section >




            </div>



        </div >

    )
}

export default Dailycashreport
